<template>
	<div>
		<ed-modal 
			:title="'Desativar nova Empresa'" 
			:modal="showFormEdit" 
			:loadingSave="config.loading.save"
			:onSave="salvar"
			width="95%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<ed-form :data="formData" :config="config" :response="response" :itens="disparoItems">
					<div slot="form-footer"></div>
				</ed-form>
			</div>
		</ed-modal>

	</div>
</template>

<script>

	import Rest from 'common/rest'
	import EdForm from 'common/form'
	import EdModal from 'common/modal'
	import FormItems  from './_form/periodico-desativado-cadastrar.js'

  	export default {
  		name:"empresa",
  		components: {EdForm,EdModal},
		mixins:[Rest],
		props:{
			parent:{
                type: Object,
                default: null
			},
			showForm:{
				type: Boolean,
                default: false
			}
		},
		watch: {
			showForm(){
				this.showFormEdit = !this.showFormEdit;
				this.inicialize();
			},
			'formData.id_emp'(){
				this.config.disabled.id_fun = (!this.formData.id_emp ? true : false);
				this.getFuncionario();
			},
		},
  		data () {
		   	return {
				config:{
					tipo:[244,250],
					click:{
						id_emp:this.getEmpresa,
						id_fun:this.getFuncionario,
					},
					loading:{
						save:false,
						id_emp:false,
						id_fun:false
					},
					list:{
						id_emp:[],
						id_fun:[]
					},
					disabled:{
						id_fun:true,
						funcionario_todos:true,
					},
					hidden:{
						ativo:true
					},
				},
				response:{},
				disparoItems:[],
				formData:{
					id:0,
					empresa_todos:1,
					funcionario_todos:0,
					id_emp:null,
					id_fun:[],
				},
				showFormEdit:false
			}
		},

		created(){
		},

		mounted: function() {
			this.disparoItems = FormItems;
			this.getEmpresa();
		},
		methods: {

			inicialize(){
				this.formData ={
					id:0,
					empresa_todos:1,
					funcionario_todos:0,
					id_emp:null,
					id_fun:[],
				}
			},

			getEmpresa(search){

				this.config.loading.id_emp = true;
				this.config.list.id_emp = [];
				
				this.get('empresa',{search:search}).then((result)=>{
					result = result[0];

					this.config.loading.id_emp = false;

					if(result.status == 200){
						this.config.list.id_emp = result.data.data;
					}
				});
			},

			getFuncionario(search){

				if(!this.formData.id_emp)return;

				this.config.loading.id_fun = true;
				this.config.list.id_fun = [];
				
				this.get('empresa/funcionario/'+this.formData.id_emp,{search:search}).then((result)=>{
					result = result[0];

					this.config.loading.id_fun = false;

					if(result.status == 200){
						this.config.list.id_fun = result.data.data;
					}
				});
			},

			salvar: function(){
				
				this.config.loading.save = true;
				this.response = {};
				
				this.post('/periodico/desativado/editar',this.formData).then((result)=>{

					result = result[0];
						
					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Dados atualizados')
						this.showFormEdit = !this.showFormEdit;
						if(this.parent)
							this.parent.getDesativado();
					}
				});
			}

		}
  	}
</script>


// WEBPACK FOOTER //
// cadastrar.vue?29a42852